/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/now.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns current date and time.
 *
 * @example
 * ROW current_date = NOW()
 *
 * @example
 * FROM sample_data
 * | WHERE @timestamp > NOW() - 1 hour
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'now',
  signatures: [
    {
      params: [],
      variadic: false,
      returnType: 'date',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
